/* eslint-disable react/prop-types */
import * as React from 'react';

function ProfileMenuIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="36" height="36" rx="18" fill="#4FC4C0" />
      <g clipPath="url(#clip0_11115_65346)">
        <path
          d="M17.8457 19.2236C16.9336 19.2237 16.0418 18.9533 15.2834 18.4466C14.5249 17.9399 13.9337 17.2196 13.5846 16.3769C13.2354 15.5342 13.1441 14.6069 13.322 13.7122C13.4999 12.8176 13.9392 11.9958 14.5842 11.3508C15.2292 10.7058 16.051 10.2665 16.9456 10.0886C17.8403 9.91066 18.7676 10.002 19.6103 10.3511C20.453 10.7003 21.1733 11.2915 21.68 12.0499C22.1867 12.8084 22.4571 13.7001 22.4571 14.6123C22.4556 15.8349 21.9692 17.0069 21.1048 17.8714C20.2403 18.7358 19.0683 19.2221 17.8457 19.2236ZM17.8457 11.5996C17.25 11.5995 16.6676 11.7761 16.1722 12.107C15.6767 12.4379 15.2906 12.9083 15.0625 13.4587C14.8344 14.0091 14.7747 14.6147 14.8908 15.199C15.0069 15.7834 15.2937 16.3201 15.7149 16.7415C16.1361 17.1628 16.6728 17.4498 17.2571 17.5661C17.8414 17.6824 18.4471 17.6229 18.9975 17.395C19.548 17.1671 20.0185 16.781 20.3495 16.2857C20.6806 15.7904 20.8574 15.2081 20.8575 14.6123C20.8565 13.8138 20.539 13.0482 19.9744 12.4834C19.4098 11.9186 18.6443 11.6008 17.8457 11.5996ZM26.5996 21.5996C26.5995 21.3876 26.5152 21.1842 26.3653 21.0342C26.2153 20.8842 26.0119 20.7999 25.7998 20.7998H9.79983C9.69456 20.7995 9.59025 20.8199 9.49289 20.8599C9.39553 20.8999 9.30702 20.9588 9.23245 21.0331C9.15788 21.1074 9.09872 21.1957 9.05835 21.2929C9.01797 21.3901 8.99719 21.4944 8.99719 21.5996C8.99719 21.7049 9.01797 21.8091 9.05835 21.9064C9.09872 22.0036 9.15788 22.0919 9.23245 22.1662C9.30702 22.2405 9.39553 22.2993 9.49289 22.3394C9.59025 22.3794 9.69456 22.3998 9.79983 22.3994H25.7998C26.0119 22.3993 26.2153 22.315 26.3653 22.1651C26.5152 22.0151 26.5995 21.8117 26.5996 21.5996ZM26.5996 24.8213C26.5995 24.6092 26.5152 24.4059 26.3653 24.2559C26.2153 24.1059 26.0119 24.0216 25.7998 24.0215H9.79983C9.69456 24.0211 9.59025 24.0416 9.49289 24.0816C9.39553 24.1216 9.30702 24.1805 9.23245 24.2548C9.15788 24.3291 9.09872 24.4174 9.05835 24.5146C9.01797 24.6118 8.99719 24.716 8.99719 24.8213C8.99719 24.9266 9.01797 25.0308 9.05835 25.128C9.09872 25.2253 9.15788 25.3136 9.23245 25.3879C9.30702 25.4622 9.39553 25.521 9.49289 25.5611C9.59025 25.6011 9.69456 25.6215 9.79983 25.6211H25.7998C26.0119 25.621 26.2153 25.5367 26.3653 25.3867C26.5152 25.2368 26.5995 25.0334 26.5996 24.8213Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_11115_65346">
          <rect
            width="17.5996"
            height="15.6211"
            fill="white"
            transform="translate(9 10)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

const MemoNoData = React.memo(ProfileMenuIcon);
export default MemoNoData;
